import React from 'react';
import './during-stay-survey.scss';
import {connect} from 'react-redux';
import {getActiveLanguage, getTranslate} from 'react-localize-redux';
import {Col, Grid, Row} from 'react-bootstrap';
import {bindActionCreators} from 'redux';
import {duringStaySurveyGetAnswer, duringStaySurveySendAnswer} from './../../actions';
import AlreadyAnswerMessage from 'components/during-stay-survey/AlreadyAnswerMessage';
import Spinner from 'components/during-stay-survey/Spinner';
import FeedbackForm from 'components/during-stay-survey/FeedbackForm';

class DuringStaySurvey extends React.Component {
  constructor(props) {
    super(props);

    this.sendSurvey = this.sendSurvey.bind(this);
  }

  componentDidMount() {
    this.props.actions.duringStaySurveyGetAnswer(
      this.props.token, this.props.currentLanguage, this.props.context);
  }

  sendSurvey({content, rating}) {
    this.props.actions.duringStaySurveySendAnswer(
      content, rating,
      this.props.token, this.props.currentLanguage, this.props.context);
  }

  render() {
    let component;
    if (this.props.loading) {
      component = <Spinner/>;
    } else if (this.props.error) {
      component = <p>{this.props.translate(this.props.error)}</p>;
    } else if (this.props.status === 'EXPIRED') {
      component =
          <AlreadyAnswerMessage>{this.props.translate('duringStaySurvey.expired1')}<br /><br />{this.props.translate('duringStaySurvey.expired2')}</AlreadyAnswerMessage>;
    } else if (this.props.status === 'DONE') {
      component =
        <AlreadyAnswerMessage>{this.props.translate('duringStaySurvey.alreadyAnswer')}</AlreadyAnswerMessage>;
    } else {
      component = <FeedbackForm onSubmit={this.sendSurvey} submitting={this.props.submitting}
                                translate={this.props.translate}/>;
    }

    return <Grid>
      <Row><Col xs={12} sm={8} smOffset={2}>
        <div className="content">
          {component}
        </div>
      </Col></Row>
    </Grid>;
  }
}

const mapStateToProps = (state) => ({
  status: state.duringStaySurvey.status,
  translate: getTranslate(state.locale),
  currentLanguage: getActiveLanguage(state.locale).code,
  token: state.commons.token,
  loading: state.duringStaySurvey.loading,
  submitting: state.duringStaySurvey.submitting
});
const mapDispatchToProps = (dispatch) => ({
  actions: {
    duringStaySurveyGetAnswer: bindActionCreators(duringStaySurveyGetAnswer, dispatch),
    duringStaySurveySendAnswer: bindActionCreators(duringStaySurveySendAnswer, dispatch),
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(DuringStaySurvey);




// WEBPACK FOOTER //
// ./components/pages/DuringStaySurvey.js